<script>
import { versoesNaoVistas, rotuloVersao, formatarDataVersao, marcarVersaoVista } from "@/utils/versao";

/**
 * Sino de notificações da barra superior.
 *
 * Hoje a única fonte é o versionamento (utils/versao.js): cada versão que o
 * usuário ainda não abriu em /novidades vira uma notificação. O componente já
 * trabalha com uma lista genérica ({ id, icon, title, text, date, to }) para
 * receber outras fontes (ex.: uma caixa de notificações na API) sem mudar a
 * apresentação — basta concatenar em `notificacoes`.
 */
export default {
  name: "NotificationsBell",
  computed: {
    // Reativo: versoesNaoVistas() lê estadoVersao.vista (Vue.observable), então
    // o sino apaga sozinho quando /novidades marca a versão como vista.
    notificacoes() {
      return versoesNaoVistas().map((v) => ({
        id: "versao:" + v.version,
        icon: "bx-gift",
        title: `Nova versão ${rotuloVersao(v.version)}: ${v.title}`,
        text: v.summary,
        date: formatarDataVersao(v.date),
        to: "/novidades",
      }));
    },
    total() {
      return this.notificacoes.length;
    },
  },
  methods: {
    abrir(n) {
      if (n.to && n.to !== this.$route.path) this.$router.push(n.to);
    },
    marcarTodas() {
      marcarVersaoVista();
    },
  },
};
</script>

<template>
  <b-dropdown right no-caret variant="link" class="st-bell" toggle-class="st-icon-btn" menu-class="st-bell-menu">
    <template #button-content>
      <span class="sr-only">Notificações{{ total ? ` (${total} não lidas)` : "" }}</span>
      <i class="bx bx-bell" :class="{ 'bx-tada-hover': total }" aria-hidden="true"></i>
      <span v-if="total" class="st-bell-dot" aria-hidden="true">{{ total > 9 ? "9+" : total }}</span>
    </template>

    <b-dropdown-header class="st-bell-header">
      <span>Notificações</span>
      <button v-if="total" type="button" class="btn btn-link btn-sm p-0" @click.stop="marcarTodas">Marcar como lidas</button>
    </b-dropdown-header>

    <b-dropdown-item v-for="n in notificacoes" :key="n.id" link-class="st-bell-item" @click="abrir(n)">
      <span class="st-bell-item-icon" aria-hidden="true"><i class="bx" :class="n.icon"></i></span>
      <span class="st-bell-item-text">
        <strong>{{ n.title }}</strong>
        <small>{{ n.text }}</small>
        <time>{{ n.date }}</time>
      </span>
    </b-dropdown-item>

    <div v-if="!total" class="st-bell-empty">
      <i class="bx bx-check-circle" aria-hidden="true"></i>
      <p>Tudo em dia por aqui.</p>
    </div>

    <b-dropdown-divider />
    <b-dropdown-item to="/novidades" link-class="st-bell-all">Ver todas as novidades</b-dropdown-item>
  </b-dropdown>
</template>
